import React, { useState, useEffect } from 'react';
import Header from '../secciones/Header/index';
import Intro from '../secciones/Intro/index';
import Body from '../secciones/Body/index';
import Footer from '../secciones/Footer/index';
import NotFound from '../secciones/NotFound';

// Material Loading
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

import axios from 'axios';

const config = require('../../configuration');

export const Principal = () => {

    const [stateEstado, setStateEstado] = useState(true);
    const [stateMetadata, setStateMetadata] = useState([]);
    const [stateTipo, setStateTipo] = useState(1);

    let params = new URLSearchParams(window.location.search);
    let id = params.get('id');
    let id_campaign = (id === undefined || id === '' || isNaN(id)) ? 0 : id;

    const useStyles = makeStyles((theme) => ({
        backdrop: {
          zIndex: theme.zIndex.drawer + 1,
          color: '#fff',
        },
    }));

    const classes = useStyles();

    const cargaMetadata = async () => {

        await axios.get(`${config.API_BASE_URL_ENCUESTAS_DESTACADAS}/service-verificar-campaign-landing/id/${id_campaign}`)
        .then(response => {
            if(response){
                const { data } = response.data;

                if(data.length === 0)
                {
                    setStateEstado(false);
                    setStateTipo(0)
                }else{
                    setStateMetadata(data);

                    setStateEstado(false);
                }
            }
       });
    }

    useEffect(() => {   
        cargaMetadata();
        console.log(stateMetadata)
    },[]);

    return (
        <>
            {!stateEstado
                ? stateTipo === 1 ?
                    <>
                        <Header />
                        <Intro
                            setStateEstado = { setStateEstado } 
                            stateMetadata = { stateMetadata }
                        />
                        <Body />
                        <Footer /> 
                    </> : 
                    <>
                        <Header />
                        <NotFound />
                    </>
                :
                <> 
                    <Backdrop className={classes.backdrop} open={stateEstado}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                </>
            }
        </>
    )
};